import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { Decimal } from 'decimal.js';

import { BetslipPick } from '../../../core/picks/betslip-pick';
import { IBetslip } from '../../bet-generation/models';
import { calculateWinningsBoost } from '../../reward-tokens/services/reward-tokens.utils';
import { IBetslipSummary, ISlipSummary } from '../models';
import { OddsBoostSummary } from '../models/odds-boost-summary.model';

export function getOddsBoostWinningsBoost(summary: IBetslipSummary): Nullable<Decimal> {
    const oddsBoostSummaries = summary.slipSummaries.filter((slipSummary) => slipSummary.rewardTokenModifications?.oddsBoost);
    if (!oddsBoostSummaries.length) {
        return null;
    }

    const winningsBoost = summary.slipSummaries.reduce(
        (totalWinningsBoost, slipSummary) => totalWinningsBoost.plus(getWinningsBoost(slipSummary)),
        new Decimal(0),
    );

    return winningsBoost;
}

export function getOddsBoostWinnings(summary: IBetslipSummary): OddsBoostSummary {
    const oddsBoost = summary.slipSummaries[0]?.rewardTokenModifications?.oddsBoost;
    if (!oddsBoost) {
        return { boostedOdds: null, boostedWinnings: null, winningsBoost: null };
    }

    const winningsBoost = getOddsBoostWinningsBoost(summary);

    return { ...oddsBoost, winningsBoost };
}

function getWinningsBoost(slipSummary: ISlipSummary) {
    return calculateWinningsBoost(slipSummary);
}

export function getBetslipPicks(betslip: IBetslip): BetslipPick[] {
    return betslip.slips.flatMap((slip) => Object.values(slip.slipPicks)).map((pick) => pick.pick);
}
